import React from 'react';

import { AutoplayMode } from './AutoplayMode';
import { PlaysInlineMode } from './PlaysInlineMode';

export const Autoplay: React.FC = () => {
  /**
   * playsinline is required for autoplay on iOS. So we make it as part as autoplay.
   * see for details https://player.support.brightcove.com/playback/autoplay-considerations.html
   */
  return (
    <>
      <PlaysInlineMode />
      <AutoplayMode />
    </>
  );
};
